package fr.labodoc.healthProfessional.api.payloads.requests

import fr.labodoc.domain.labodoc.common.NotificationFrequency
import kotlinx.serialization.Serializable

@Serializable
data class MedicalCardCPSRegistrationRequest(
  val medicalCardNumber: String,
  val firstName: String,
  val lastName: String,
  val healthDirectoryProfessionCode: String,
  val healthDirectoryProfessionalCategoryCode: String,
  val healthDirectoryProfessionalStatusCode: String,
  val healthDirectoryExpertiseCode: String?,
  val healthDirectoryPharmacistSectionCode: String?,
  val labodocMedicalProfessionId: String,
  val labodocMedicalSpecialityId: String,
  val labodocMedicalInterestIds: List<String>,
  val departmentCode: String,
  val notificationFrequency: NotificationFrequency?,
  val email: String,
  val password: String,
  val partnerCode: String?
)
